'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Image(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 30 : _ref$size;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 20 20',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(-2.000000, -2.000000)',
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('rect', { fill: '#48487E', x: 2, y: 2, width: 20, height: 20, rx: 4 }),
      _react2.default.createElement('path', {
        d: 'M6 17c2.055-3.111 3.513-4.667 4.374-4.667.861 0 1.653.311 2.375.934.5-1.511 1.333-2.267 2.499-2.267 1.166 0 2.084 2 2.752 6H6zm5.5-7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z',
        fill: '#FFF'
      })
    )
  );
}

Image.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Image;